export function mp3Player(audioFilePath, playerElement) {
  // Fetch podcast details from data attributes
  const podcastTitle =
    playerElement.getAttribute("data-podcast-title") || "no title found";
  const podcastSubtitle =
    playerElement.getAttribute("data-podcast-subtitle") || "no subtitle found";
  const podcastUrl = window.location.href;

  return {
    audio: null,
    audioFile: audioFilePath,
    isPlaying: false,
    currentTime: 0,
    duration: 0,
    progress: 0,
    initPlayer() {
      this.audio = this.audioFile.audio;
    },
    seek(event) {
      this.audioFile.currentTime = event.target.value;
      sendDataLayerEvent(
        "seek",
        Math.round(this.progress),
        podcastTitle,
        podcastSubtitle,
        podcastUrl
      );
    },
    updateSeek(event) {
      const progressBarWidth = event.currentTarget.offsetWidth;
      const clickPositionX = event.clientX;
      const seekPercentage = (clickPositionX / progressBarWidth) * 100;
      const seekTime = (this.duration * seekPercentage) / 100;
      this.currentTime = seekTime;
      this.audioFile.duration.currentTime = seekTime;
      sendDataLayerEvent(
        "seek",
        Math.round(this.progress),
        podcastTitle,
        podcastSubtitle,
        podcastUrl
      );
    },
    setDuration() {
      this.duration = this.audioFile.duration;
    },
    updateProgress() {
      this.currentTime = this.audioFile.currentTime;
      this.duration = this.audioFile.duration;
      this.progress = (this.currentTime / this.duration) * 100;

      if (this.currentTime === this.duration) {
        this.isPlaying = false;
      }
    },
    togglePlayback(audioFile) {
      this.isPlaying = !this.isPlaying;

      if (this.isPlaying) {
        audioFile.play();
        sendDataLayerEvent(
          "play",
          Math.round(this.progress),
          podcastTitle,
          podcastSubtitle,
          podcastUrl
        );
      } else {
        audioFile.pause();
        sendDataLayerEvent(
          "pause",
          Math.round(this.progress),
          podcastTitle,
          podcastSubtitle,
          podcastUrl
        );
      }
    },
    formatTime(time) {
      const minutes = Math.floor(time / 60);
      const seconds = Math.floor(time % 60)
        .toString()
        .padStart(2, "0");
      return `${minutes}:${seconds}`;
    },
  };
}

function sendDataLayerEvent(
  action,
  percent,
  podcastTitle,
  podcastSubtitle,
  podcastUrl
) {
  window._jts = window._jts || [];
  window._jts.push({
    track: "event", // Jentis State
    type: "podcast", // Eventname
    podcast_title: podcastTitle, // Titel des Podcast
    podcast_subtitle: podcastSubtitle, // Subtitel des Podcast
    podcast_url: podcastUrl, // vollständige URL zur Seite
    podcast_action: action, // Interaktion mit dem Player, wie "play, pause, forward, reward, end"
    podcast_duration: percent + "%", // Prozentualer Anteil, an dem die Interaktion erfolgte
  });
}
